import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ColorData } from '../../core/models/color-data'
@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.css']
})
export class ColorPickerComponent implements OnInit {
  
  @Input() eventId: string;
  @Input() colorValue: string;
  @Input() groupname: string;
  @Output() sendColor = new EventEmitter<ColorData>();

  colorData = new ColorData();

  otherColor1: string = null;
  otherColor2: string = null;
  otherColor3: string = null;
  otherColor4: string = null;
  otherColor5: string = null;
  otherColor6: string = null;
  otherColor7: string = null;
  otherColor8: string = null;

  color: string = null;
  colorClass: string = null;
  constructor() { }

  ngOnInit() {
    // console.log('pankaj', this.eventId);
    // console.log('pankaj', this.colorValue);
    if (this.colorValue) {
      this.clearClass();
      if (this.colorValue == '#FFFFFF') {
        this.otherColor1 = this.colorValue;
      } else if (this.colorValue == '#2D383A') {
        this.otherColor2 = this.colorValue;
      } else if (this.colorValue == '#736A62') {
        this.otherColor3 = this.colorValue;
      } else if (this.colorValue == '#2EB4E6') {
        this.otherColor4 = this.colorValue;
      } else if (this.colorValue == '#00468C') {
        this.otherColor5 = this.colorValue;
      } else if (this.colorValue == '#D92121') {
        this.otherColor6 = this.colorValue;
      } else if (this.colorValue == '#00755E') {
        this.otherColor7 = this.colorValue;
      } else if (this.colorValue == '#E77200') {
        this.otherColor8 = this.colorValue;
      } else {
        this.color = this.colorValue;
        this.colorClass = 'add_color';
      }
    }
  }

  clearClass() {
    this.colorClass = null;
  }

  colorChange(color: string) {
    if (color) {
      this.colorClass = 'add_color';
      this.colorData.splash_cutom_bg_color = color;
      this.clearColorValue();
      this.sendColor.emit(this.colorData);
    }
  }

  getColor(value) {
    this.clearClass();
    this.color = null;
    this.colorData.splash_cutom_bg_color = value;
    this.sendColor.emit(this.colorData);
  }

  clearColorValue() {
    this.otherColor1 = null;
    this.otherColor2 = null;
    this.otherColor3 = null;
    this.otherColor4 = null;
    this.otherColor5 = null;
    this.otherColor6 = null;
    this.otherColor7 = null;
    this.otherColor8 = null;
  }

}



// WEBPACK FOOTER //
// /app/src/app/layout/color-picker/color-picker.component.ts